module.exports = __webpack_public_path__ + "img/main.3c12f830.jpg";